import React, { useContext } from 'react';
import { UserContext } from './UserContext';
import './App.css';
import certificateBackground from './images/CertificateBackground.png';
import defaultPhoto from './images/Profile.png'; // Import default image

const Certificate = React.forwardRef((props, ref) => {
  const { userDetails } = useContext(UserContext);

  const getGrade = (percentage) => {
    if (percentage >= 80) return 'उत्तम Excellent';
    if (percentage >= 65) return 'प्रथम First';
    if (percentage >= 40) return 'द्वितीय Second';
    return 'No Grade';
  };

  const percentage = (props.totalScore > 0 && props.score >= 0)
    ? (props.score / props.totalScore) * 100
    : 0;

  const grade = getGrade(percentage);

  return (
    <div ref={ref} className="certificate" style={{ backgroundImage: `url(${certificateBackground})` }}>
      <h4 className='mt-4'>Sanatana Guru Sampradaya Pratishthanam</h4>
      <h4>सनातन गुरु सम्प्रदाय प्रतिष्ठानम्</h4>
      <h5>Veda Vijnaana Vishtaram</h5>
      <h5>वेद विज्ञान विष्टरम् संस्कृत विभागः</h5>
      <div className="photo-name-section">
        <p>स्पर्धा - वर्णमालिका स्पर्धा Test - Varnamalika Test</p>
        <img
          src={userDetails.photo ? userDetails.photo : defaultPhoto}
          alt="User"
          className="certificate-photo"
        />
        <p>स्पर्धालु नाम- {userDetails.name}</p>
      </div>
      <p>प्रतिशतम् - Percentage Result: {percentage.toFixed(2)}%</p>
      <div className="grade-table">
        <div
          className={`grade-cell ${percentage >= 80 ? 'highlight' : ''}`}
        >
          उत्तम Excellent >=80
        </div>
        <div
          className={`grade-cell ${percentage >= 65 && percentage < 80 ? 'highlight' : ''}`}
        >
          प्रथम First >=65
        </div>
        <div
          className={`grade-cell ${percentage >= 40 && percentage < 65 ? 'highlight' : ''}`}
        >
          द्वितीय Second >=40
        </div>
      </div>
      <p>श्रेणि: Grade: {grade}</p>
      <p>अयि भोः – अभिनन्दनानि। अग्रगामी स्याः। अधीष्व व्याकरणम्।</p>
      <p>Hello Noble! Nice Job. Go ahead! Study Grammar!</p>
    </div>
  );
});

export default Certificate;
